import React, { useState, useEffect, useCallback } from 'react';
import TabPanel from 'devextreme-react/tab-panel';
import { useAuth } from '../../contexts/auth';
import notify from 'devextreme/ui/notify';
import { Button } from 'devextreme-react/button';
import { useNavigate } from 'react-router-dom';
import {getAPIReportData} from '../../api/api'
import { LoadIndicator } from 'devextreme-react/load-indicator';
import {
  SIFDefinitions,
  SIFConditionsByCategory,
  SIFActualVsPotential,
  SIFEventsByBasin,
  SIFEventsAndInjuries,
  SIFTimeOfEvent,
  SIFDisciplineActivityTask,
  SIFReportData
} from '../../components';
import { DateBox } from 'devextreme-react/date-box';
import './sif.scss';



export default function SIF() {
  const navigate = useNavigate();
  const { user, refreshSession } = useAuth();
  const now = new Date();
  const minDate = new Date().setDate(now.getDate()-1000); // 2 weeks before the current date
  const maxDate = new Date().setDate(now.getDate()); // 2 weeks after the current date
  const [startDate, setStartDate] = useState(new Date().setDate(now.getDate()-1000)); // 2 weeks before the current date
  const [endDate, setEndDate] = useState(new Date().setDate(now.getDate())); // 2 weeks after the current date
  const [originalData, setOriginalData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [isWriter, setIsWriter] = useState(false);

  const reportTabs = [
  {
    title: 'Definitions',
    icon: "far fa-newspaper",
    children: (<SIFDefinitions/>)
  },
  {
    title: 'Events, Injuries, Fatalities',
    icon: "fas fa-map-marked-alt",
    children: (<SIFEventsByBasin data={originalData} startDate={startDate} endDate={endDate}/>)
  },
  {
    title: 'Events, Injuries, Fatalities',
    icon: "far fa-chart-bar",
    children: (<SIFEventsAndInjuries data={originalData} startDate={startDate} endDate={endDate}/>)
  },
  {
    title: 'Actual vs Potential',
    icon: "fas fa-map-marked-alt",
    children: (<SIFActualVsPotential data={originalData} startDate={startDate} endDate={endDate}/>)
  },
  {
    title: 'Categories, Conditions',
    icon: "fas fa-project-diagram",
    children: (<SIFConditionsByCategory data={originalData} startDate={startDate} endDate={endDate}/>)
  },
  {
    title: 'Discipline, Activity, Sub-activity',
    icon: "fas fa-project-diagram",
    children: (<SIFDisciplineActivityTask data={originalData} startDate={startDate} endDate={endDate}/>)
  },
  {
    title: 'Time of Event',
    icon: "far fa-chart-bar",
    children: (<SIFTimeOfEvent data={originalData} startDate={startDate} endDate={endDate}/>)
  },
  {
    title: 'Report Data',
    icon: "fas fa-database",
    children: (<SIFReportData data={originalData} startDate={startDate} endDate={endDate}/>)
  }
];

  const onDataSuccess = useCallback((data) => {
    setOriginalData(data);
    setLoading(false);
  }, [setOriginalData])

  const onError = useCallback((error) => {
    if (error.status === 401) {
      refreshSession();
    } else {
      notify("An error has occured. Please try again later.", 'error', 2000);
      console.log(error);
    }
  }, [refreshSession]);

  useEffect(() => {
    if (user.signInUserSession) {
      let groups = user.signInUserSession.idToken.payload['cognito:groups']
      var has_perm=false;
      if (groups) {
        for (var i=0; i<groups.length; i++) {
          if (groups[i].includes("sifro")) {
            has_perm=true;
          }
          if (groups[i].includes("sifrw")) {
            has_perm=true;
            setIsWriter(true);
          }
          if (groups[i]==='admin') {
            has_perm=true;
            setIsWriter(true);
          }
        }
      }

      if (!has_perm) {
        notify("Insufficient permissions. Please contact the system administrator.", 'error', 5000);
        navigate('/home');
        return
      }
      getAPIReportData('/reports/sif', user, {}, onDataSuccess, onError);
    }
  }, [user, navigate, onDataSuccess, onError]);

  const onStartDateChanged = (e) => {
    setStartDate(e.value);
  }
  const onEndDateChanged = (e) => {
    setEndDate(e.value);
  }

  function TabPanelItem({ data }) {
    return <div className="tabpanel-item px-3">{data.children}</div>;
  }


  if(!loading) {
  return (
    <React.Fragment>
      <div className='content-block d-flex flex-row justify-content-between'>
      <h2>Serious Injury or Fatality Report</h2>
      <div className='d-flex flex-row'>
      {isWriter && <Button
        text="Company Data"
        stylingMode="outlined"
        type="default"
        onClick={() => {navigate("/sifdata")}}
      />}

      </div>
      </div>
      <hr className="mt-0 mb-5"></hr>
      <div className={'content-block'}>
        <div className="d-flex flex-row mb-3">
        <DateBox
            type="date"
            min={minDate}
            max={maxDate}
            width="200px"
            value={startDate}
            onValueChanged={onStartDateChanged}
            label="Start Date"
            labelMode="floating"
            showDropDownButton={false}
            onFocusIn={(e) => {e.component.open();}}
        />
        <div className="px-2"/>
        <DateBox
            type="date"
            min={startDate}
            max={maxDate}
            width="200px"
            value={endDate}
            onValueChanged={onEndDateChanged}
            showDropDownButton={false}
            label="End Date"
            labelMode="floating"
            onFocusIn={(e) => {e.component.open();}}
        />
        </div>
        <div className={'dx-card responsive-paddings'}>
          <TabPanel
            width="100%"
            height={"auto"}
            animationEnabled={false}
            swipeEnabled={true}
            dataSource={reportTabs}
            tabsPosition={'left'}
            stylingMode={'secondary'}
            iconPosition={'left'}
            itemComponent={TabPanelItem}
          />
        </div>
      </div>
    </React.Fragment>
  )
} else {
  return (
    <div className="d-flex flex-row justify-content-center align-items-center mt-5 pt-5">
        <LoadIndicator
            id="large-indicator"
            height={60}
            width={60}
        />
    </div>
  )
}

}
